"use strict";
var PROPER_FUNCTION_NAME = require("../internals/function-name").PROPER;
var fails = require("../internals/fails");
var whitespaces = require("../internals/whitespaces");
var non = "\u200B\x85\u180E";
module.exports = function(METHOD_NAME) {
  return fails(function() {
    return !!whitespaces[METHOD_NAME]() || non[METHOD_NAME]() !== non || PROPER_FUNCTION_NAME && whitespaces[METHOD_NAME].name !== METHOD_NAME;
  });
};
